module.exports = "//docs.gtimg.com/slide/img/framework/editor/src/img/pageIndex/toolbar/image-transparent-932542.svg";